import { Helmet } from 'react-helmet-async';

type Props = {
  title: string;
  description: string;
  /** Either a relative path (joined to ORIGIN) or an absolute URL. */
  path: string;
  image?: string | null;
  type?: 'website' | 'article' | 'profile';
  /** When true, asks crawlers not to index this page (private share links). */
  noindex?: boolean;
  jsonLd?: object | object[];
};

const ORIGIN = 'https://flowtokos.com';

export function SEO({ title, description, path, image, type = 'website', noindex, jsonLd }: Props) {
  const url = path.startsWith('http') ? path : `${ORIGIN}${path}`;
  const ldArray = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];
  const card = image ? 'summary_large_image' : 'summary';
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      {image && <meta property="og:image" content={image} />}
      <meta name="twitter:card" content={card} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {image && <meta name="twitter:image" content={image} />}
      {ldArray.map((ld, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(ld)}</script>
      ))}
    </Helmet>
  );
}
